import { getSupabase } from '@/lib/supabase';

/**
 * The WhatsApp templates, through the whatsapp-templates edge function (owner, 2026-10-04:
 * "complete the whatsapp registration of templates"). The browser never sees the token: it asks
 * what Meta holds, asks for the missing ones to be registered, and asks for a test to itself.
 */
export interface TemplateStatusRow {
  name: string; language: string; category: 'UTILITY' | 'AUTHENTICATION'; keys: string[]; document: boolean;
  status: string; rejected_reason: string | null; id: string | null;
}
export interface TemplateStatus {
  waba_id: string; phone_number_id: string; origin: string;
  languages_switched_on: string[]; languages_ready: string[]; rows: TemplateStatusRow[];
}
export interface RegisterOutcome {
  registered: number; failed: number; remaining: number;
  results: Array<{ name: string; language: string; ok: boolean; status?: string; id?: string; error?: string }>;
}
export interface TestOutcome {
  results: Array<{ channel: 'email' | 'whatsapp'; destination_masked: string; language: string; delivered: boolean; error?: string }>;
}

async function call<T>(body: Record<string, unknown>): Promise<T> {
  const { data, error } = await getSupabase().functions.invoke('whatsapp-templates', { body });
  if (error) {
    type Failure = { error?: string; results?: unknown };
    const payload: Failure = await ((error as { context?: Response }).context?.json?.() as Promise<Failure> | undefined)?.catch(() => ({} as Failure)) ?? {};
    // A partial test outcome comes back on a 502 with its results: that is an answer, not a failure.
    if (payload.results) return payload as T;
    const status = (error as { context?: Response }).context?.status;
    throw new Error(payload?.error ?? (status === 404 ? 'The whatsapp-templates function is not deployed yet.' : 'The request failed.'));
  }
  return data as T;
}

export const templateStatus = () => call<TemplateStatus>({ action: 'status' });
export const registerTemplates = (limit = 25) => call<RegisterOutcome>({ action: 'register', limit });
export const sendTemplateTest = (input: { channels: Array<'email' | 'whatsapp'>; templateKey: string; pdfBase64?: string; filename?: string }) =>
  call<TestOutcome>({ action: 'test', channels: input.channels, template_key: input.templateKey, pdf_base64: input.pdfBase64, filename: input.filename });
